import React from 'react'
import joshLogo from '../../assets/verse-logo.svg'
function LogoHeader() {
    return (
        <>
            <div className='header-wrap flex-justify' id="header-container">
                <img className='josh-logo' src={joshLogo} alt="" />
            </div>
        </>
    )
}

export default LogoHeader